import isISO8601 from 'validator/lib/isISO8601';
import { z } from 'zod';

import { LoginId } from 'backend-client-web';

import { HeymergeListElement } from '../heymerge';
import { ISODateString } from '../types';
import {
  UnprotectedLogin,
  UnprotectedLoginWithoutHistoryListElement,
} from '../vaultContent/login/UnprotectedLogin';

// Linked login update messages carry no revision history (extractLinkedUpdateMessages
// strips it), so the content type omits it — keeping the message JSON-serializable.
type LinkedLoginUpdateMessageV1 = Array<
  | {
      type: 'originUpdated';
      loginId: LoginId;
      content: HeymergeListElement<Omit<UnprotectedLogin, 'history'>>;
    }
  | {
      type: 'targetDeleted';
      loginId: LoginId;
      removeTime: ISODateString;
    }
>;
const LinkedLoginUpdateMessageV1 = z.array(
  z.union([
    z.object({
      type: z.literal('originUpdated'),
      loginId: z.uuid(),
      content: UnprotectedLoginWithoutHistoryListElement,
    }),
    z.object({
      type: z.literal('targetDeleted'),
      loginId: z.uuid(),
      removeTime: z.string().refine((str) => isISO8601(str)),
    }),
  ]),
);

export { LinkedLoginUpdateMessageV1 };
